import React from 'react';
import { features } from '../../mock/mock';
import BrowserFrame from './BrowserFrame';
import * as Mockups from './ProductMockups';
import AppIcon from '../AppIcon';

const FEATURE_MAP = { 'wedding-dashboard': 'overview', invitations: 'invitations', 'rsvp-page': 'rsvp', 'guests-list': 'guests', 'ai-friend': 'ai', seating: 'seating', budget: 'budget', vendors: 'vendors', timeline: 'timeline', website: 'website', registry: 'registry' };

export default function FeatureShowcase() {
  return (
    <section id="features" className="py-24 lg:py-32 bg-gradient-to-b from-[#FBF7F2] to-[#F6EAE0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <p className="section-eyebrow">All in one workspace</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 text-[#2A2A2A] leading-tight">
            Seven tools, working together <span className="italic text-[#7B2C3B]">for your day</span>.
          </h2>
          <p className="mt-5 text-[#4A4A4A] leading-relaxed">
            Quietly replaces a dozen scattered tools, six group chats and that notebook with crumbs in it.
          </p>
        </div>

        <div className="space-y-24">
          {features.map((f, i) => {
            const Mock = Mockups[f.mockup];
            return (
              <div
                key={f.id}
                id={f.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                  i % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''
                }`}
              >
                <div className="relative">
                  <BrowserFrame url={`yourweddingfriends.com/${f.id}`}>
                    {Mock ? <Mock /> : <div className="p-10 text-sm text-[#9A8A7E]">Preview coming soon</div>}
                  </BrowserFrame>
                  <div className="absolute -bottom-6 -right-6 hidden lg:block">
                    <span className="font-script text-2xl text-[#7B2C3B] -rotate-6 inline-block">
                      {`— ${f.eyebrow.toLowerCase()}`}
                    </span>
                  </div>
                </div>
                <div className="group">
                  <div className="flex items-center gap-3">
                    <AppIcon feature={FEATURE_MAP[f.id] || 'overview'} size="lg" interactive reveal testId={`feature-icon-${f.id}`} />
                    <p className="section-eyebrow">{f.eyebrow}</p>
                  </div>
                  <h3 className="font-serif text-3xl lg:text-4xl mt-3 text-[#2A2A2A] leading-tight">
                    {f.title}
                  </h3>
                  <p className="mt-5 text-[#4A4A4A] text-lg leading-relaxed max-w-xl">
                    {f.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
